import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useContext } from 'react';
import { CampaignContext } from '../../context/CampaignWrapper';

export const useLanguage = () : string => {
  const { campaign: { organisation: { locale: tenantLocale } } } = useContext(CampaignContext);
  const [search] = useSearchParams();
  const queryParamLocale = search.get('lang');
  const location = useLocation();
  const navigate = useNavigate();

  const properlyCased : {
    [key: string]: string,
  } = {
    nl: 'nl-BE',
    'nl-be': 'nl-BE',
    'nl-nl': 'nl-NL',
    fr: 'fr-BE',
    'fr-be': 'fr-BE',
    de: 'de-DE',
    'de-de': 'de-DE',
    en: 'en-GB',
    'en-gb': 'en-GB',
    null: 'nl-BE',
  };
  const queryParams = new URLSearchParams(location.search);
  const properlyCasedQueryParam = properlyCased[(queryParamLocale || '').toLowerCase()];
  if (properlyCasedQueryParam && queryParamLocale !== properlyCasedQueryParam) {
    queryParams.set('lang', properlyCasedQueryParam);
    // Replace current querystring with the new one.
    navigate(`${location.pathname}?${queryParams.toString()}${location.hash || ''}`, { replace: true });
  }
  return tenantLocale || properlyCasedQueryParam || 'nl-BE';
};
